module.exports = __webpack_public_path__ + "img/filter-welcome-background-honda.c8242038.png";